<div class="panel-shell">
  <header class="panel-header">
    <div class="panel-title text-bold">
      {{ "SELECT_PLACE.TITLE" | translate }}
    </div>
    <button
      mat-icon-button
      type="button"
      class="panel-close-btn"
      (click)="close()"
      aria-label="Close panel"
    >
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="panel-body">
    <mat-form-field floatLabel="auto" class="search-field">
      <mat-label>{{ "GENERIC.SEARCH" | translate | titlecase }}</mat-label>
      <input id="search" [(ngModel)]="filterValue" matInput #filter />
      <button
        mat-button
        *ngIf="filterValue"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="clearSearch()"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div #comboList class="container-border flex-column rooms-list">
      <div *ngIf="isLoading" class="flex-column-center-center">
        <mat-spinner [diameter]="20" class=""></mat-spinner>
      </div>

      <div *ngIf="!isLoading" class="rooms-list-inner">
        <cdk-virtual-scroll-viewport
          #venueVScroll
          [itemSize]="50"
          class="venue-list-vscroll"
        >
          <div *cdkVirtualFor="let item of places; trackBy: trackByUUID">
            <ng-container *ngIf="item.internal">
              <div
                *ngFor="let room of item.rooms"
                (click)="onSelectRoom(room, item)"
                class="room-section flex-row-space-between-center"
              >
                <div>{{ room.name }}</div>
                <mat-radio-button
                  class="pb-4"
                  [checked]="selectedRoom === room"
                ></mat-radio-button>
              </div>
            </ng-container>
          </div>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>

    <div class="mt-8 selected-label text-bold" *ngIf="selectedRoom">
      {{ "SELECT_PLACE.SELECTED_ROOM" | translate }}: {{ selectedRoom.name }}
    </div>
  </div>

  <footer class="panel-footer gt2-buttons-theme flex-row-center-center">
    <button
      mat-raised-button
      [disabled]="!selectedRoom"
      (click)="onRoomSelected()"
      color="accent"
      class="mr-8 ml-8 mt-4 mb-4"
    >
      {{ "GENERIC.SELECT" | translate }}
    </button>
    <button
      mat-raised-button
      (click)="close()"
      class="mr-8 ml-8 mt-4 mb-4 primary"
    >
      {{ "GENERIC.CANCEL" | translate }}
    </button>
  </footer>
</div>
